module.exports = __webpack_public_path__ + "static/media/restart.3e36b9d9.svg";